import React from 'react'
export const NotFound = (): React.ReactElement => <h1>Page Not Found Page</h1>
